import React, { useState, useEffect, useRef } from "react";
import PrimaryButton from "../../elements/primary-button";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { BackgroundImage } from "../../elements";
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
import gsap from 'gsap';
import Swiper from 'swiper';
let activeIndex = 0;
const ColorInChange = ({ page, lang, rendering, fields }) => {
  const {
    list,
    title,
    desc
  } = fields;
  const isAR = page?.fields?.rtl?.value;
  const mainId = `c-color-in-change${rendering.uid}`
  let colorSwiper = useRef(null)
  const swiper = useRef(null);
  const swiperEl = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [oldCurrentIndex, setOldCurrentIndex] = useState(-1)
  const [isActive, setIsActive] = useState(false)
  const [isClick, setIsClick] = useState(false)
  const [progress, setProgress] = useState(null)
  const [btnProps, setBtnProps] = useState({})
  const isMobile = mobileIs()
  const rootNode = useRef(null);

  const buildSwiper = () => {
    const options = {
      speed: 1000,
      slidesPerView: 1,
      watchSlidesProgress: true,
      effect: 'fade',
      reverseDirection: isAR ? true : false,
      on: {
        slideChangeTransitionStart(swiper) {
          setCurrentIndex(swiper.realIndex)
        },
      },
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  const destroySwiper = () => {
    if (swiper.current) {
      swiper.current.destroy(true, true);
      swiper.current = null;
    }
    if (colorSwiper.current) {
      colorSwiper.current.destroy(true, true);
      colorSwiper.current = null;
    }
  };

  const initMagicScroll = () => {
    let ScrollMagic = loadScrollMagic();
    let tl = gsap.timeline();
    let controller = new ScrollMagic.Controller();
    let scene = new ScrollMagic.Scene({
      triggerElement: rootNode.current,
			offset: 0,
      triggerHook: "onLeave",
      duration: "400%"
    }).setPin(`#${mainId}`).setTween(tl).addTo(controller);
    

    scene.on("progress", function(event) {
      setProgress(event.progress)
    });
    return () => {
      scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    }
  };

  const changeTab = (index, type, click) => {
    if(index === activeIndex) return false;
    if(click){
      setOldCurrentIndex(activeIndex)
      setCurrentIndex(index)
      activeIndex=index
    }
    if(swiper.current) {
      swiper.current.slideTo(index, 0, false)
    }
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let domOffsetTop = rootNode.current?.offsetTop;
        let length = list.length;
    if(type === 'click') {
      setIsClick(true)
      let itemHeight = 1 / length;
      let targetProgress = itemHeight * index + itemHeight / 2;
      let scrollPosition = domOffsetTop + pageHeight * 4 * targetProgress;
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
      setTimeout(v => {
        setIsClick(false)
      }, 1000)
    }
  }

  useEffect(() => {
    let listLength = list.length
    let itemHeight = 1 / listLength
    for(let i=0;i<listLength;i++) {
      if(progress >= itemHeight * i && progress < itemHeight * (i+1) && !isClick) {
        changeTab(i, 'scroll',true)
      }
      if(i === listLength - 1 && progress >= itemHeight * i && !isClick) {
        changeTab(i, 'scroll',true)
      }
    }
  }, [isClick, progress])

  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let domOffsetTop = rootNode.current?.getBoundingClientRect()?.top
    if (domOffsetTop < pageHeight / 3 * 2 + 100) {
      setIsActive(true)
    } else {
      setIsActive(false)
    }
  }

  useEffect(() => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let wrapDom = document.querySelector('.color-swiper-wrapper')
    if(isMobile) {
      if(isAR) {
        wrapDom.style.transform = 'translateX('+ ((pageWidth - 72) / 2 - 72 * currentIndex) * -1 +'px)'
      } else {
        wrapDom.style.transform = 'translateX('+ ((pageWidth - 72) / 2 - 72 * currentIndex) +'px)'
      }
    }


    let btnProps = {
      buttonText: list[currentIndex]?.fields?.buttonText,
      colorScheme: list[currentIndex]?.fields?.colorScheme,
      iconName: list[currentIndex]?.fields?.iconName,
      link: list[currentIndex]?.fields?.link
    }
    setBtnProps(btnProps)
  },[currentIndex])

  useEffect(() => {
    initMagicScroll()
    document.querySelector('.c-color-in-change_color_content .swiper-wrapper').style.justifyContent = list.length < 6 ? 'center' : 'initial'
    setTimeout(v=>{
      buildSwiper()
    }, 1000)
    // 上下居中
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    let mainDom = document.querySelector('.c-color-in-change-main')
    if(!isMobile) {
      // mainDom.style.paddingTop = (pageHeight - mainDom.clientHeight) / 2 + 'px'
    } else {
      mainDom.style.paddingTop = (pageHeight - 580) / 2 + 'px'
      mainDom.style.paddingBottom = (pageHeight - 580) / 2 + 'px'
    }

    window.addEventListener("scroll", onScroll);
    return () => {
      destroySwiper();
      window.removeEventListener("scroll", onScroll);
    };
  },[])
  
  const rootClasses = classNames("c-color-in-change", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <div id={mainId} className="c-color-in-change-main">
        <RichText tag="div" className={["c-color-in-change_title", isActive ? 'active' : ''].join(' ')} field={title} />
        <RichText tag="div" className={["c-color-in-change_desc", isActive ? 'active' : ''].join(' ')} field={desc} />
        
        <div className="c-color-in-change_swiper swiper" ref={swiperEl}>
          <div className="swiper-wrapper">
            {list && list.map((item, index) => (
              <div className="swiper-slide grid swiper-no-swiping" key={index}>
              {list && list.map((inItem, inIndex) => (
                <div key={inIndex} className={classNames("car-image slide-inner",
                inIndex === index && index == currentIndex ? 'active' : '',
                (inIndex == oldCurrentIndex && index === currentIndex ) || (inIndex === currentIndex && index != currentIndex ) ? 'oldActive' : ''
                )}>
                  <BackgroundImage {...inItem?.fields?.carImage} className={'car-innner-image'} />
                </div>
              ))}
              </div>
            ))}
          </div>
        </div>
				
				<div className="color-btn-content">
					<div className="c-color-in-change_color_content swiper">
						<div className="swiper-wrapper color-swiper-wrapper">
							{list && list.map((item, index) => (
								<div className={["swiper-slide color-item", index === currentIndex ? 'active' : ''].join(' ')} key={index} onClick={(e) => changeTab(index, 'click', true)}>
									<div className={["color-circle", index === currentIndex ? 'active' : ''].join(' ')}>
                    <div className="color-circle-inner" style={{backgroundColor: item?.fields?.color?.value}}></div>
									</div>
									<RichText tag="div" className={["color-name", index === currentIndex ? 'active' : ''].join(' ')} field={item?.fields?.colorName} />
								</div>
							))}
						</div>
					</div>
				
					{ btnProps && btnProps?.buttonText?.value && btnProps?.link?.value &&
						<div className="btn-content">
							<div className="btn-content-main">
									<PrimaryButton {...btnProps} />
							</div>
						</div>
					}
				</div>
      </div>
    </div>
  );
};

export default ColorInChange;